import type { ReactNode } from "react";

import { classNames } from "@alpacahq/ui/old";

import type { PaymentMethod } from "../../types";

interface PaymentMethodToggleProps {
  paymentMethod: PaymentMethod;
  onPaymentMethodChange: (paymentMethod: PaymentMethod) => void;
  isBankAccountEnabled?: boolean;
}

export const PaymentMethodToggle = ({
  paymentMethod,
  onPaymentMethodChange,
  isBankAccountEnabled = true,
}: PaymentMethodToggleProps) => (
  <div className="flex items-center gap-2">
    {isBankAccountEnabled && (
      <Tab
        isSelected={paymentMethod === "plaid"}
        onClick={() => onPaymentMethodChange("plaid")}
      >
        Bank Account
      </Tab>
    )}
    <Tab
      isSelected={paymentMethod === "stripe"}
      onClick={() => onPaymentMethodChange("stripe")}
    >
      Credit / Debit Card
    </Tab>
  </div>
);

interface TabProps {
  children: ReactNode;
  isSelected: boolean;
  onClick: () => void;
}

const Tab = ({ children, isSelected, onClick }: TabProps) => (
  <button
    className={classNames(
      "rounded-full px-3 py-1 font-semibold text-sm transition-colors duration-200",
      isSelected
        ? "bg-indigo-100 text-gray-700"
        : "bg-transparent text-gray-500 hover:text-gray-700",
    )}
    onClick={onClick}
    type="button"
  >
    {children}
  </button>
);
